'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const User = require('../../global/models/User');
const ContextComponent = require('../../global/components/ContextComponent');
const favoritePageActions = require('../../global/actions/favoritePageActions');

class FavoriteButton extends ContextComponent {
    constructor(props) {
        super(props);

        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._handleClick = this._handleClick.bind(this);

        this.state = {
            mouseIsOver: false,
            isLoading: false,
        };
    }

    componentDidMount() {
        User.getCurrentUser().on('login:change', () => {
            this._fetchFavoritePage();
        });

        this._fetchFavoritePage();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isSaved !== this.props.isSaved) {
            this.setState({ isLoading: false });
        }
    }

    _fetchFavoritePage() {
        if (User.loggedIn()) {
            const { resetCollection, favoriteData: { type, page } } = this.props;
            this.context.executeAction(favoritePageActions.fetchFavoritePage, {
                resetCollection,
                type,
                page,
            });
        }
    }

    _onMouseEnter() {
        this.setState({ mouseIsOver: true });
        this.props.onMouseEnter();
    }

    _onMouseLeave() {
        this.setState({ mouseIsOver: false });
        this.props.onMouseLeave();
    }

    _handleClick(event) {
        event.preventDefault();
        const { isLoading } = this.state;

        if (isLoading) {
            return;
        }

        if (User.loggedIn()) {
            this.setState({ isLoading: true });
        }

        if (this.props.isSaved) {
            this._removeFromFavorites();
        } else {
            this._saveToFavorites();
        }

        this.props.onClick();
        this.props.onMouseLeave();
    }

    _saveToFavorites() {
        const {
            favoriteData: { page, type, name, primaryKey, authModalOptions },
            tracking: { save: tracking },
        } = this.props;
        const payload = { page, type, name, primaryKey, authModalOptions, tracking };
        this.context.executeAction(favoritePageActions.saveToFavorites, payload);
    }

    _removeFromFavorites() {
        const { id, tracking: { remove: tracking } } = this.props;
        const payload = { id, tracking };
        this.context.executeAction(favoritePageActions.removeFromFavorites, payload);
    }

    render() {
        const { mouseIsOver } = this.state;
        const { cta, isSaved } = this.props;
        let buttonText = cta[isSaved.toString()];

        if (buttonText && buttonText.default && buttonText.hover) {
            buttonText = mouseIsOver ? buttonText.hover : buttonText.default;
        }

        return (
            <a
                href="#"
                className={this.props.className}
                data-tn="item-save"
                onMouseEnter={this._onMouseEnter}
                onMouseLeave={this._onMouseLeave}
                onClick={this._handleClick}
            >
                {buttonText}
            </a>
        );
    }
}

FavoriteButton.defaultProps = {
    favoriteData: {
        page: '',
        name: '',
        type: '',
        primaryKey: '', // used for favoriting dealers/designers
        authModalOptions: {},
    },
    tracking: {
        save: {},
        remove: {},
    },
    onClick() {},
    onMouseEnter() {},
    onMouseLeave() {},
};

FavoriteButton.propTypes = {
    id: PropTypes.number,
    className: PropTypes.string,
    favoriteData: PropTypes.shape({
        type: PropTypes.string.isRequired,
        page: PropTypes.string,
        primaryKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        authModalOptions: PropTypes.object,
    }),
    cta: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    isSaved: PropTypes.bool.isRequired,
    isFetched: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    resetCollection: PropTypes.bool,
};

module.exports = FavoriteButton;



// WEBPACK FOOTER //
// ./assets/js/components/FavoriteCta/FavoriteButton.jsx